module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325506/philosophy01_sp-50d311d7a70ebd71d85a87fb00a92172.png";